import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class KAEDetail  {
    _originalTypeClassName = "zERP.BO.KAEDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
KAEDetail.translate = translateService;
}
this.Lookup = [];
this.EntityFieldDTO = [];
this.Id = null;
this.KAECode = null;
this.EntityName = null;
this.FieldName = null;
this.ValueType = null;
this.nValue = null;
this.bValue = false;
this.ValueFrom = null;
this.ValueTo = null;
this.ValueQuery = null;
this.AttributeSystemEntity = null;
this.Priority = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
KAECode:any;
EntityName:any;
FieldName:any;
ValueType:any;
nValue:any;
bValue:any;
ValueFrom:any;
ValueTo:any;
ValueQuery:any;
AttributeSystemEntity:any;
Priority:any;
Lookup:any;
EntityFieldDTO:any;
static setLookup = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lookup == null) $this.Lookup = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lookup.length > 0) {
                    Domain.KAEDetail.removeLookup($this, $this.Lookup[0]);
                }

                Domain.KAEDetail.addManyLookup($this, copyItems);
            }
static addManyLookup = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.KAEDetail.addLookup($this, items[i]);
                }
            }
static addLookup = ($this, item) => {
                if ($this.Lookup == null) $this.Lookup = [];
                if (item == null || $this.Lookup.indexOf(item) > -1) return;
                $this.Lookup.push(item);
}
static addRangeLookup = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.KAEDetail.addLookup($this, item));
            }
static removeLookup = ($this, item) => {
                if ($this == null || $this.Lookup == null || $this.Lookup.indexOf(item) === -1) return;
                var _index = $this.Lookup.indexOf(item);
                $this.Lookup.splice(_index, 1);
}
static clearLookup = ($this) => { $this.Lookup = null; }
static setEntityFieldDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.EntityFieldDTO == null) $this.EntityFieldDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EntityFieldDTO.length > 0) {
                    Domain.KAEDetail.removeEntityFieldDTO($this, $this.EntityFieldDTO[0]);
                }

                Domain.KAEDetail.addManyEntityFieldDTO($this, copyItems);
            }
static addManyEntityFieldDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.KAEDetail.addEntityFieldDTO($this, items[i]);
                }
            }
static addEntityFieldDTO = ($this, item) => {
                if ($this.EntityFieldDTO == null) $this.EntityFieldDTO = [];
                if (item == null || $this.EntityFieldDTO.indexOf(item) > -1) return;
                $this.EntityFieldDTO.push(item);
}
static addRangeEntityFieldDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.KAEDetail.addEntityFieldDTO($this, item));
            }
static removeEntityFieldDTO = ($this, item) => {
                if ($this == null || $this.EntityFieldDTO == null || $this.EntityFieldDTO.indexOf(item) === -1) return;
                var _index = $this.EntityFieldDTO.indexOf(item);
                $this.EntityFieldDTO.splice(_index, 1);
}
static clearEntityFieldDTO = ($this) => { $this.EntityFieldDTO = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}